import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalViewMoreFamily from "root/Modals/ViewMoreFamily/ModalViewMoreFamily";

const useModalViewMoreFamily = () =>
{
    const [dialog, setDialog]  = useState ( { openState: false, families: null, title: null })  ;

    const onClickActivate = ( families, title ) =>
    {
        setDialog ({ openState: true, families, title });
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, key: null, families: null, title: null });
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                <ModalViewMoreFamily 
                    onClose={onCloseModal} families={dialog.families} title={dialog.title}
                />
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalViewMoreFamily ;
